module.exports = __webpack_public_path__ + "img/m_dianshanbg.ae144d18.jpg";